package de.oevbs.kunde.kundenportal2.services.registration

import de.oevbs.kunde.kundenportal2.ProgressStep
import dev.fritz2.core.RenderContext
import dev.fritz2.core.joinClasses
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map

class ProgressStepper<T : ProgressStep> {

    var steps: List<T> = emptyList()
    var stepFormat: (T) -> String = { it.toString() }

    var activeStep: Flow<T> = flowOf()

    private fun isActiveStep(step: T): Flow<Boolean> =
        activeStep.map { active -> active == step }

    fun RenderContext.render() {
        div("grid grid-flow-col grid-rows-1 md:grid-rows-[auto_auto] auto-cols-fr justify-items-stretch gap-y-2") {
            steps.forEachIndexed { index, step ->
                stepIndicator(label = "${index + 1}", isActiveStep(step))
                stepLabel(label = stepFormat(step), isActiveStep(step))
            }
        }
    }

    private fun RenderContext.stepIndicator(label: String, active: Flow<Boolean>) {
        div(
            joinClasses(
                "relative flex justify-center items-center",
                "before:content-[''] before:absolute before:top-[50%] before:left-0 before:right-0",
                "before:border before:border-t before:border-secondary-200"
            )
        ) {
            div(
                joinClasses(
                    "relative p-3 flex justify-center items-center rounded-full",
                    "vui-labelbig-3 text-white",
                )
            ) {
                className(active.map {
                    if (it) "w-12 h-12 bg-primary-700"
                    else "w-10 h-10 bg-secondary-200"
                })
                span("-mt-0.5") {
                    +label
                }
            }
        }
    }

    private fun RenderContext.stepLabel(label: String, active: Flow<Boolean>) {
        div(
            // Wichtig: Der Aufbau des umgebenden Grids ist abhängig von der unten gesetzten Visibility! Ist dieses
            // label nicht sichtbar, ist darauf zu achten, dass das Styling des umgebenden Grids dies korrekt
            // berücksichtigt.
            "hidden md:flex justify-center text-sm font-semibold"
        ) {
            className(active.map {
                if (it) "text-primary-700"
                else "text-secondary-200"
            })
            +label
        }
    }
}

fun <T : ProgressStep> RenderContext.progressStepper(initialize: ProgressStepper<T>.() -> Unit) {
    ProgressStepper<T>().run {
        initialize()
        render()
    }
}